import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { fetchMe } from '../../../actions/user/me';
import { getSessionToken } from '../../../selectors/session';
import { useAppDispatch } from '../../../store';
import { UnleashFeatureNames } from '../../Unleash/featureNames';
import { FeatureFlag } from '../types';

// SessionInitializer calls fetchMe() before feature flags have loaded, so the
// first /me request defaults to the v1 endpoint. This hook runs once flags are
// available and re-fetches /me with v2 when empMigrateMeToV2 is enabled.
export default function useRefetchMeForV2Migration(
  features: FeatureFlag[] | undefined
) {
  const dispatch = useAppDispatch();
  const sessionToken = useSelector(getSessionToken);
  const hasRefetchedRef = useRef(false);

  useEffect(() => {
    if (hasRefetchedRef.current || !sessionToken) {
      return;
    }

    const isEnabled = features?.some(
      feature => feature.name === UnleashFeatureNames.empMigrateMeToV2
    );

    if (isEnabled) {
      hasRefetchedRef.current = true;
      dispatch(fetchMe());
    }
  }, [features, sessionToken, dispatch]);
}
